"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCard = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var error_card_styles_1 = require("./error_card.styles");
var ErrorCard = function (_a) {
    var headline = _a.headline, description = _a.description, pillButton = _a.pillButton, children = _a.children;
    return (react_1.default.createElement(error_card_styles_1.ErrorsBody, null,
        react_1.default.createElement(error_card_styles_1.StyledCard, null,
            react_1.default.createElement(storm_ui_1.Text, { type: 'h2' }, headline),
            react_1.default.createElement(error_card_styles_1.ErrorMessageContainer, null,
                react_1.default.createElement(error_card_styles_1.StyledText, { fontSize: "base" }, description)),
            pillButton && (react_1.default.createElement(error_card_styles_1.StyledButton, { primary: true, href: pillButton.link }, pillButton.text)),
            children)));
};
exports.ErrorCard = ErrorCard;
